export default "__VITE_ASSET__7FtEJb3W__"